import AddIcon from "@mui/icons-material/Add";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { NavLink, useNavigate } from 'react-router-dom';
import CheckIcon from "@mui/icons-material/Check";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import TelegramIcon from "@mui/icons-material/Telegram";
import { Box, Button, Grid, Typography } from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import InputEmoji from "react-input-emoji";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import AlertElem from "../../components/Alert";
import User from '../../components/User';
import Skeleton from '@mui/material/Skeleton';
import UserAvatar from "../../components/UserAvatar";
import { setConversations } from "../../redux/conversationSlice";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { messageThunk, setUser } from "../../redux/messageSlice";
import { showSideBar, showThread } from '../../redux/mobileChatSlice'
import { setStatus } from '../../redux/loaderSlice'
import Utils from "../../utils/Utils";
import Nodes from "../../utils/Nodes";
import CuModel from "../../components/CuModel";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState as useMenuState } from 'react';
import FlagIcon from '@mui/icons-material/Flag';
import { reportConversation } from "../../redux/conversationSlice";
import MessageBubble from "./MessageBubble";
const { serverURL } = Utils;
const { updateIsBlockStatus } = Nodes;


export default function Chat({ socket, scrollDown, openViewModel }) {
  const theme = useTheme();
  let messages_ = useSelector((state) => state.message.data);
  const receiverProfile = useSelector((state) => state.message.user);
  const liveUser = useSelector((state) => state.liveUser.liveUsers);
  const messageReadIds = useSelector((state) => state.messageRead.ids);
  const conversationsId = useSelector((state) => state.message.conversationsId);
  const conversationsData = useSelector((state) => state.conversation.conversations);
  const messageBarStatus = useSelector((state) => state.messageBarSlice.isSend);
  const loader = useSelector((state) => state.loaderSlice.status);
  const userProfile = useSelector((state) => state.auth.profile);
  const [message, setMessage] = useState("");
  const [sendMsgIsRead, setSendMsgIsRead] = useState(false);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  let thread_id = searchParams.get("thread_id");
  const scrollableDivRef = useRef(null);
  const messageRefs = useRef([]);
  const chatLatestRef = useRef(null);
  const loaderRef = useRef(null);
  const [nowData, setNowDate] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [loading, setLoading] = useState(true);
  const [fileName, setFileName] = useState('');
  const [showFileUploadStatus, setFileUploadStatus] = useState(false);
  const [showFileUploadError, setFileUploadError] = useState(false);
  const [progress, setProgress] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const [alertMessageType, setAlertMessageType] = useState('')
  const { t, i18n } = useTranslation();
  const [showUserBlockModel, setShowUserBlockModel] = useState(false)
  const matches = useMediaQuery('(max-width:899px)');
  const navigate = useNavigate();
  const [userMessagePlanType, setUserMessagePlanType] = useState(60)
  const [isThreadBlocked, setThreadBlocked] = useState(false)
  const isSend = useSelector(state => state.messageBarSlice.isSend)
  const [skip, setSkip] = useState(0)
  const [isLoadingMore, setIsLoadingMore] = useState(false)

  useEffect(() => {
    let receiverId = receiverProfile.id;
    let senderId = userProfile._id;
    let messagesData = messages_.filter((data_) => {
      return data_.conversationId === thread_id;
    });
    if (messagesData.length > 0) {
      let messages = messagesData[0].data;
      let receverMessage = messages.filter(
        (message) =>
          message.user.id !== senderId && message.conversationId == thread_id,
        message.is_read === false
      );
      let messageIds = receverMessage.map((message) => message.id);
      let messageStatus = isSend.find((threadData) => threadData.conversationId === thread_id)
      if (messageStatus) {
        if (messageStatus.isSend) {
          socket?.emit("readMessage", { senderId, receiverId, messageIds });
        }
      }

    }

  }, [socket, messages_, liveUser]);

  useEffect(() => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const formattedTime = `${hours % 12 || 12}:${minutes
      .toString()
      .padStart(2, "0")} ${hours >= 12 ? "PM" : "AM"}`;
    setNowDate(formattedTime);
  }, []);

  useEffect(() => {
    let profilePic_ =
      "https://img.freepik.com/free-psd/3d-illustration-human-avatar-profile_23-2150671142.jpg?size=626&ext=jpg";
    if (receiverProfile?.profilePic?.profilePic?.url) {
      profilePic_ = receiverProfile?.profilePic?.profilePic?.url;
    }

    setProfilePic(profilePic_);
  }, [receiverProfile]);

  useEffect(() => {
    if (scrollDown && scrollableDivRef.current) {
      scrollableDivRef.current.scrollTo({
        top: scrollableDivRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [scrollDown]);

  useEffect(() => {
    let receiverId = receiverProfile.id;
    let senderId = userProfile._id;
    let messagesData = messages_.filter((data_) => {
      return data_.conversationId === thread_id;
    });
    if (messagesData.length > 0) {
      let messages = messagesData[0].data;
      let receverMessage = messages.filter(
        (message) =>
          message.user.id !== senderId && message.conversationId == thread_id
      );
      let messageIds = receverMessage.map((message) => message.id);
      const interval = setInterval(() => {
        if (thread_id === conversationsId) {
          let messageStatus = isSend.find((threadData) => threadData.conversationId === thread_id)
          if (messageStatus) {
            if (messageStatus.isSend) {
              socket?.emit("readMessage", { senderId, receiverId, messageIds });
            }

          }

        }
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [conversationsId, message, messages_]);

  useEffect(() => {
    messageRefs.current = messageRefs.current.slice(0, messages_.length);
  }, [messages_]);


  const smoothScrollToBottom = (duration = 1000) => {
    if (!scrollableDivRef.current || !chatLatestRef.current) return;
    const chatWindow = scrollableDivRef.current;
    const targetPosition = chatLatestRef.current.offsetTop;
    const startPosition = chatWindow.scrollTop;
    const distance = targetPosition - startPosition;
    let startTime = null;
    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      chatWindow.scrollTop = run; // Scroll the chat window
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
    requestAnimationFrame(animation);
  };

  useEffect(() => {
    setSkip(0);
    if (thread_id) {
      let payLoad_ = { conversationId: thread_id, userId: userProfile._id, skip: 0 };
      dispatch(messageThunk(payLoad_));
    }
  }, [thread_id]);

  // useEffect(() => {
  //   if (skip === 0 && scrollableDivRef.current) {
  //     setTimeout(() => {
  //       scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
  //     }, 150);
  //   }
  // }, [messages_, skip]);


  const messageChangeHandler = (e) => {
    setMessage(e);
  };

  const messageSendHandler = async () => {

    let senderId = userProfile._id;
    const { id } = receiverProfile
    socket?.emit("checkPlanStatus", { senderId, receiverId: id, conversationsId: thread_id });

    let response = true

    async function checkPlanStatus(socket) {
      return new Promise((resolve, reject) => {
        try {
          socket?.on("checkPlanStatusSignal", (status) => {
            if (status && status.planType === 0) {
              setUserMessagePlanType(0);
              setAlertMessageType('error');
              setErrorMessage("Messages can't be sent as you're now a free user.");
              setFileUploadError(true);
              resolve(false);
            } if (status && status.planType === 1) {
              setUserMessagePlanType(1);
              setAlertMessageType('error');
              setErrorMessage("Messages can't be sent as you're now a free user.");
              setFileUploadError(true);
              resolve(false);
            } else {
              resolve(true);
            }
          });
        } catch (error) {
          resolve('end')
        }
      });
    }
    let socketResponse = await checkPlanStatus(socket)
    if (socketResponse == 'end') {
      response = true
    } else {
      response = socketResponse
    }


    if (response) {
      socket?.emit("sideBarUsers", { senderId });
      const handleSideBarUsers = (data) => {
        if (data?.data.length > 0) {
          dispatch(setConversations({ conversations: data.data }));
        }
      };
      socket?.on("setSideBarUsers", handleSideBarUsers);
      if (message !== "") {
        let updatedConversationsData = conversationsData.map((conversation) => {
          if (conversation.conversationId === thread_id) {
            return { ...conversation, latestMessage: message };
          }
          return conversation;
        });

        dispatch(setConversations({ conversations: updatedConversationsData }));

        setSendMsgIsRead(true);
        let receiverId = receiverProfile.id;
        let senderId = userProfile._id;
        socket.emit("sendMessage", {
          receiverId,
          senderId,
          conversationsId: thread_id,
          message,
        });
        setMessage("");
        setTimeout(() => {
          scrollToBottom()
        }, 1000)

      }
    }
  };

  const handleKeyDown = (e) => {
    messageSendHandler();
  };

  const fileUpload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.style.display = "none";
    input.addEventListener("change", (event) => {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        const fileName = selectedFile.name;
        setFileName(fileName)
        setFileUploadStatus(true)
        handleFileUpload(
          selectedFile,
          receiverProfile.id,
          userProfile._id,
          thread_id
        );
      }
    });

    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
    window.scrollTo(0, document.body.scrollHeight);
  };

  const handleFileUpload = (file, receiverId, senderId, conversationsId) => {
    const formData = new FormData();

    const receiverLiveUserData = liveUser.find(user => user.userId === receiverId);
    const senderLiveUserData = liveUser.find(user => user.userId === userProfile._id);

    if (receiverLiveUserData) {
      formData.append("receiverSocketId", receiverLiveUserData.socketId);
    }

    if (senderLiveUserData) {
      formData.append("senderSocketId", senderLiveUserData.socketId);
    }

    formData.append("file", file);
    formData.append("senderId", senderId);
    formData.append("conversationId", conversationsId);

    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentCompleted = Math.round((event.loaded * 100) / event.total);
        setProgress(percentCompleted);
      }
    };

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 413) {
          openAlertMesssage(t('chat.fileSizeError'), 'error')
        } else if (xhr.status === 200) {
          openAlertMesssage(t('chat.fileUploadSuccess'), 'success')
        } else {
          openAlertMesssage(t('chat.fileUploadError'), 'error')
        }
      }
    };

    xhr.onerror = () => {
      openAlertMesssage(t('chat.fileUploadError'), 'error')
    };

    xhr.open("POST", `${serverURL}/chat/upload`, true);
    xhr.send(formData);

    setTimeout(() => {
      scrollToBottom();
    }, 1000);

  };

  const openAlertMesssage = (message, messageType) => {
    setAlertMessageType(messageType)
    setFileUploadStatus(false);
    setFileUploadError(true);
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
      setFileUploadError(false);
    }, 6000);
  }

  const getFileNameFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      const pathname = urlObject.pathname;
      return pathname.substring(pathname.lastIndexOf("/") + 1);
    } catch (error) {
      return t("chat.notAvailable");
    }
  };

  const getMediaTypeFromUrl = (url) => {
    const extension = url.split(".").pop().split(/[\?#]/)[0];
    const mediaTypes = {
      jpg: "image",
      jpeg: "image",
      png: "image",
      gif: "image",
      webp: "image",
      svg: "image",
      pdf: "file",
      txt: "file",
      css: "file",
      js: "file",
      html: "file",
      docx: "file",
      ppk: "file",
      json: "file",
      mp3: "audio",
      wav: "audio",
      ogg: "audio",
      flac: "audio",
      aac: "audio",
      mp4: "video",
      webm: "video",
      mov: "video",
      avi: "video",
      mkv: "video",
      m4a: "video",
      aiff: "audio",
      m3u: "audio",
      pls: "audio",
      dll: "file",
    };
    return mediaTypes[extension] || "message";
  };

  const getDateLabel = (date) => {
    const today = new Date();
    const messageDate = new Date(date);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (messageDate.toDateString() === today.toDateString()) {
      return t("chat.today");
    }
    if (messageDate.toDateString() === yesterday.toDateString()) {
      return t("chat.yesterday")
    }
    return messageDate.toDateString();
  };

  const groupMessagesByDate = (messages) => {
    // Group messages by date label, reverse the order to show latest date at the bottom
    if (messages.length > 0) {
      let messagesData = messages.filter((data_) => {
        return data_.conversationId === thread_id;
      });
      if (messagesData.length > 0) {
        
        messages = [...messagesData[0].data].sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        );
        const reversedMessages = [...messages].reverse();
        return reversedMessages.reduce((groups, message) => {
          const dateLabel = getDateLabel(message.createdAt);
          if (!groups[dateLabel]) {
            groups[dateLabel] = [];
          }
          groups[dateLabel].push(message);
          return groups;
        }, {});
      }
    }
  };

  const groupedMessages = groupMessagesByDate(messages_);

  const formatDate = (date) => {
    const options = { hour: "2-digit", minute: "2-digit" };
    return new Date(date).toLocaleTimeString([], options);
  };

  const scrollToBottom = () => {
    chatLatestRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.style.display = "none";
    e.target.nextElementSibling.style.display = "block";
  };

  const onClose = () => {
    setFileUploadError(false)
  }

  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" className="upload_per" sx={{ color: 'text.secondary' }}>
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  const fetchMessages = async () => {
    if (isLoadingMore) return;

    try {
      setIsLoadingMore(true);
      const newSkip = skip + 15;
      let payLoad_ = { conversationId: thread_id, userId: userProfile._id, skip: newSkip };
      await dispatch(messageThunk(payLoad_));
      setSkip(newSkip);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoadingMore(false);
    }
  };
  const currentThreadData = messages_.find((data) => data.conversationId === thread_id);
  const hasMoreMessages = currentThreadData?.hasMoreMessages !== false;

  // Intersection Observer for infinite scroll at the top
  useEffect(() => {
    const container = scrollableDivRef.current;
    const loader = loaderRef.current;
    
    if (!container || !loader) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLoadingMore && hasMoreMessages) {
            console.log('Loader visible, fetching older messages');
            fetchMessages();
          }
        });
      },
      {
        root: container,
        rootMargin: '50px',
        threshold: 0.01,
      }
    );

    observer.observe(loader);

    return () => {
      if (loader) observer.unobserve(loader);
      observer.disconnect();
    };
  }, [skip, isLoadingMore, thread_id, hasMoreMessages, fetchMessages]);

  const backHandler = () => {
    dispatch(showSideBar({ show_sidebar: true }))
    dispatch(showThread({ show_thread: false }))
    navigate('/messages')

  }

  const showUserBlockModelHandler = () => {
    setShowUserBlockModel(true)
  }

  const hideUserBlockModelHandler = () => {
    setShowUserBlockModel(false)
  }

  const userBlockModelHandler = async () => {
    let response = await updateIsBlockStatus(thread_id, userProfile._id)
    if (response) {
      hideUserBlockModelHandler()
      let conversationsData_ = [...conversationsData];
      const index = conversationsData_.findIndex(data => data.conversationId === thread_id);
      if (index > -1) {
        navigate('/messages')
        conversationsData_.splice(index, 1)
        dispatch(setConversations({ conversations: conversationsData_ }));

        let senderId = userProfile._id;
        let filterData = conversationsData.find((data) => data.conversationId === thread_id)
        if (filterData) {
          let receiverId = filterData.user.id
          socket?.emit("blockUser", { senderId, receiverId });
        }
        const blockUser = (data) => {
          if (data.status) {
            navigate('/messages')
          }
        }
        socket?.on("blockUserSignal", blockUser);

      }
    }
  }

  useEffect(() => {
    let msgPlanType = userProfile.planType
    let findData = messages_.find((data) => data.conversationId === thread_id)
    if (findData) {
      const lastObject = findData.data[findData.data.length - 1];
      if (lastObject) {
        if (lastObject.user.id !== userProfile._id) {
          const { user } = lastObject
          if (user.planType === 60 && msgPlanType === 0) {
            msgPlanType = 60
          } else if (user.planType === 40 && msgPlanType === 0) {
            msgPlanType = 1
          } else if (user.planType === 0 && msgPlanType === 40) {
            msgPlanType = 40
          } else if (user.planType == 0 && msgPlanType == 0) {
            msgPlanType = 1
          } else if (user.planType === 0 && msgPlanType === 60) {
            msgPlanType = 60
          } else if (user.planType === 60 && msgPlanType === 60) {
            msgPlanType = 60
          } else if (user.planType === 40 && msgPlanType === 40) {
            msgPlanType = 40
          } else if (user.planType === 40 && msgPlanType === 60) {
            msgPlanType = 60
          } else if (user.planType === 60 && msgPlanType === 40) {
            msgPlanType = 40
          }
        } else {
          const { planType } = receiverProfile
          if (planType !== undefined) {
            if (planType == 0 && msgPlanType == 0) {
              msgPlanType = 1
            } else if (planType == 40 && msgPlanType == 0) {
              msgPlanType = 1
            } else if (planType == 60 && msgPlanType == 0) {
              msgPlanType = 60
            } else if (planType == 0 && msgPlanType == 60) {
              msgPlanType = 60
            } else if (planType == 0 && msgPlanType == 40) {
              msgPlanType = 40
            } else if (planType == 40 && msgPlanType == 40) {
              msgPlanType = 40
            } else if (planType == 60 && msgPlanType == 60) {
              msgPlanType = 60
            } else if (planType == 60 && msgPlanType == 40) {
              msgPlanType = 40
            } else if (planType == 40 && msgPlanType == 60) {
              msgPlanType = 60
            }
          } else {
            msgPlanType = 60
          }
        }
      } else {
        if (msgPlanType === 0 && receiverProfile.planType == 40) {
          msgPlanType = 1
        } else if (msgPlanType === 0 && receiverProfile.planType == 0) {
          msgPlanType = 1
        }
      }
    }
    setUserMessagePlanType(msgPlanType)
    setTimeout(() => {
      dispatch(setStatus({ status: false }))
    }, 2000);

  }, [messages_])

  useEffect(() => {
    let filterData = messages_.find((data) => data.conversationId === thread_id)
    if (filterData) {
      setThreadBlocked(filterData.is_block)
    } else {
      setThreadBlocked(true)
    }

  }, [conversationsData, thread_id, messages_])

  useEffect(() => {
    let thread_id_ = localStorage.getItem('thread_id_') || false
    if (thread_id_) {
      let flilterData = conversationsData.find((threadData) => threadData.conversationId == thread_id_)
      if (flilterData) {
        const { user } = flilterData
        dispatch(setUser({ user }))
      }
    }
  }, [conversationsData])

  const handleClickNavChange = () => {
    localStorage.removeItem("thread_id_");
  };


  /**
   * State for managing the report dialog.
   */
  const [openReportDialog, setOpenReportDialog] = useState(false);

  const handleReportDialogClose = () => {
    setOpenReportDialog(false);
  };

  const handleReportConfirm = () => {
    // Here you would send the report to your backend or handle it as needed
    setOpenReportDialog(false);
    // Optionally show a snackbar/alert to inform the user
    dispatch(
      reportConversation({
        conversationId: thread_id,
        reporterId: userProfile._id,
        reportedUserId: receiverProfile.id,
      })
    )
      .then((res) => {
        setAlertMessageType("success");
        setErrorMessage(t("chat.conversationReportedSuccess"));
        setFileUploadError(true);
        setTimeout(() => {
          setErrorMessage("");
          setFileUploadError(false);
        }, 6000);
      })
      .catch((err) => {
        setAlertMessageType("error");
        setErrorMessage(t("chat.conversationReportedError"));
        setFileUploadError(true);
        setTimeout(() => {
          setErrorMessage("");
          setFileUploadError(false);
        }, 6000);
      });
  };




  /**
   * State for managing the anchor element for the more options menu.
   */
  const [anchorEl, setAnchorEl] = useMenuState(null);
  const openMoreOptionsMenu = Boolean(anchorEl);

  const handleMoreOptionsMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMoreOptionsMenuClose = () => {
    setAnchorEl(null);
  };

  const handleReportConversation = () => {
    // Add your report logic here
    setAnchorEl(null);

    console.log("Report conversation clicked");

    setOpenReportDialog(true);


  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} className="chat_header">
          <Box p={2}>
            <Grid container alignItems={"center"}>
              <Grid item xs={6}>
                <Grid container alignItems={"center"}>
                  {matches &&
                    <Grid item xs={2}>
                      <ArrowBackIosIcon onClick={() => backHandler()} />
                    </Grid>
                  }
                  <Grid item xs={3} md={2}>
                    <UserAvatar userId={receiverProfile.id} user={{ ...receiverProfile, profilePic: receiverProfile?.profilePic?.profilePic }} username={receiverProfile.username} />
                  </Grid>
                  <Grid item md={6}>
                    {receiverProfile.deletedAccount ? (
                      <Typography>
                        {t("deletedUser")}
                      </Typography>
                    ) : (
                      <User showMessage={false} username={receiverProfile.username} pageType={'feed'} posts={{ authorID: receiverProfile?.id }} />
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5} textAlign={"end"}>
                {isThreadBlocked ?
                  <Box sx={{ cursor: "pointer" }}>
                    {t("chat.blocked")}
                  </Box>
                  :
                  <Box sx={{ cursor: "pointer" }} onClick={() => { showUserBlockModelHandler() }}>
                    {t("chat.hideBlock")}
                  </Box>
                }
              </Grid>

              <Grid item xs={1} textAlign="right">
                <MoreVertIcon
                  sx={{ cursor: 'pointer' }}
                  aria-controls={openMoreOptionsMenu ? 'chat-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openMoreOptionsMenu ? 'true' : undefined}
                  onClick={handleMoreOptionsMenuClick}
                />
                <Menu
                  id="chat-menu"
                  anchorEl={anchorEl}
                  open={openMoreOptionsMenu}
                  onClose={handleMoreOptionsMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem onClick={handleReportConversation}>
                    <FlagIcon sx={{ mr: 1, color: '#e53935' }} />&nbsp;{t("chat.reportUser")}</MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          className="chat"
          ref={scrollableDivRef}
          height={"480px"}
          sx={{ overflowY: "auto", display: 'flex', flexDirection: 'column', flexFlow: 'column-reverse' }}
        >
          {loader ?
            <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', height: '350px', padding: { xs: "20px", sm: '0px' } }}>
              <Grid item xs={11} mt={1}>
                <Skeleton variant="rounded" width={300} height={70} />
              </Grid>
              <Grid item xs={11} textAlign='-webkit-right'>
                <Skeleton variant="rounded" width={210} height={60} />
              </Grid>
              <Grid item xs={11}>
                <Skeleton variant="rounded" width={210} height={55} />
              </Grid>
              <Grid item xs={11} textAlign='-webkit-right'>
                <Skeleton variant="rounded" width={270} height={70} />
              </Grid>
              <Grid item xs={11}>
                <Skeleton variant="rounded" width={250} height={60} />
              </Grid>
              <Grid item xs={11} textAlign='-webkit-right'>
                <Skeleton variant="rounded" width={300} height={55} />
              </Grid>
            </Grid>
            :
            <>
              {userMessagePlanType === 1 ?
                <Grid container sx={{ alignItems: 'center', justifyContent: 'center', height: '350px', padding: { xs: "20px", sm: '0px' } }}>
                  <Grid item={12}>
                    <Typography className="upgrade_message">
                      {t("chat.upgradeMessage")}
                    </Typography>
                    <NavLink
                      to="/plans"
                      onClick={() => {
                        handleClickNavChange();
                      }}
                    >
                      <Button
                        className="plan_btn"
                        sx={{ background: "#2a88c3", color: "#fff" }}
                      >
                        {t("chat.goToPlans")}
                      </Button>
                    </NavLink>
                  </Grid>
                </Grid>
                :
                <Box p={3.2} sx={{ display: 'flex', flexDirection: 'column-reverse', overflow: 'auto', background: theme.palette.mode === 'dark' ? '#1a1a1a' : '#fffef2', height: '100%' }}>
                  {groupedMessages && Object.keys(groupedMessages).length > 0 ? (
                    <>

                      <div ref={chatLatestRef} />
                      {Object.keys(groupedMessages).map((date) => (
                        <Box key={`date-${date}`} sx={{ display: 'flex', flexDirection: 'column-reverse' }}>
                          
                          {groupedMessages[date].map((message, index) => {
                            
                            let messageType = getMediaTypeFromUrl(message.message);
                            let filterIds = messageReadIds.filter(
                              (message_) => message_.id === message.id
                            );
                            let is_read = message.is_read;
                            if (filterIds.length > 0) {
                              is_read = filterIds[0].is_read;
                            }
                            let userId = message.user.id;
                            let name = message.message;
                            if (messageType !== 'message') {
                              name = decodeURIComponent(
                                getFileNameFromUrl(message.message)
                              );
                            }
                            return (
                              thread_id === message.conversationId && (
                                <MessageBubble
                                  key={message.id}
                                  message={message.message}
                                  messageType={messageType}
                                  userId={userId}
                                  userProfileId={userProfile?._id}
                                  formatDate={formatDate}
                                  openViewModel={openViewModel}
                                  fileName={name}
                                  isRead={is_read}
                                  createdAt={message.createdAt}
                                  nowDate={nowData}
                                />
                              )
                            );
                          })}
                          {date !== 'Invalid Date' && (
                            <Box
                              variant="caption"
                              sx={{
                                marginTop: '20px',
                                marginBottom: '28px',
                                textAlign: 'center',
                              }}
                            >
                              <Typography className="message_group" component={'span'}>
                                {date}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      ))}
                      <div
                        ref={loaderRef}
                        className={`messages-loader ${isLoadingMore ? 'loading' : ''}`}
                      >
                        {isLoadingMore && (
                          <Typography variant="caption" sx={{ ml: 1, color: '#6e6f70' }}>
                            loading...
                          </Typography>
                        )}
                      </div>
                    </>
                  ) : (
                    <Typography>{t('chat.noMessage')}</Typography>
                  )}
                </Box>
              }
            </>
          }

        </Grid>

        {userMessagePlanType != 0 && !isThreadBlocked &&
          <>
            {userMessagePlanType === 1 ?
              <></>
              :
              <Grid item xs={12} className="chat_footer" sx={{ position: "relative" }}>
                {showFileUploadStatus &&
                  <Grid
                    container
                    sx={{
                      position: 'absolute',
                      background: '#fff',
                      top: '-70px',
                      borderBottom: '1px solid #f0f2f5'
                    }}
                  >
                    <Grid item xs={12} md={10.6} pl={"12px"} m={"10px 0px"}>
                      <Box>
                        <Grid container alignItems={"center"}>
                          <Grid item xs={2} md={1}>
                            <InsertDriveFileIcon sx={{ height: "55px", width: "55px", fill: "#6e6f70" }} />
                          </Grid>
                          <Grid item xs={9} md={11}>
                            <Grid container>
                              <Grid item xs={12}>
                                <Box>
                                  <Typography fontSize={"13px"}>{fileName}</Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12} mb={0.3}>
                                <Box>
                                  <Typography fontSize={"13px"} color={"#2a88c3"}>{t("chat.uploading")}</Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={12}>
                                <LinearProgressWithLabel sx={{ borderRadius: "10px" }} value={progress} />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                }
                <Box p={2}>
                  <Grid container alignItems={"center"}>
                    {receiverProfile.deletedAccount ?
                      (<Typography sx={{ width: '100%', textAlign: 'center', py: 1 }}>
                        {t("deletedUser")}
                      </Typography>)
                      : (
                        <>
                          <Grid item xs={9} className="chat_input_container">
                            <InputEmoji
                              value={message}
                              onChange={messageChangeHandler}
                              cleanOnEnter
                              onEnter={handleKeyDown}
                              placeholder={t("chat.typeMessage")}
                            />
                          </Grid>
                          <Grid item xs={1} sx={{ ml: { xs: 0, md: 2 }, textAlign: "left" }} textAlign="left">
                            <Box sx={{ cursor: "pointer" }} onClick={fileUpload}>
                              <AddIcon />
                            </Box>
                          </Grid>
                          <Grid item xs={1} ml={0}>
                            <Box
                              sx={{
                                background: "#1976d2",
                                cursor: "pointer",
                                borderRadius: "50%",
                                height: "36px",
                                width: "36px",
                              }}
                            >
                              <TelegramIcon
                                onClick={messageSendHandler}
                                sx={{
                                  position: "relative",
                                  top: "5px",
                                  left: "3px",
                                  color: "#fff",
                                }}
                              />
                            </Box>
                          </Grid>
                        </>
                      )}
                  </Grid>
                </Box>
              </Grid>
            }
          </>
        }

        <AlertElem isAlertMessage={showFileUploadError} alertMessage={errorMessage} alertMessageType={alertMessageType} onClose={() => { onClose() }} />
      </Grid>
      <CuModel open={showUserBlockModel} onClose={() => hideUserBlockModelHandler()}>
        <Grid container sx={{ p: "20px", justifyContent: "center" }}>
          <Grid item xs={12} textAlign={"center"} p={"20px 0px"}>
            <Typography>{t("chat.hideBlockConfirm")}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Grid container textAlign={"center"}>
              <Grid item xs={6}>
                <Button className="hide_block_btn" sx={{ background: "#2a88c3", color: "#fff" }} onClick={() => hideUserBlockModelHandler()}>{t("chat.no")}</Button>
              </Grid>
              <Grid item xs={6}>
                <Button onClick={() => userBlockModelHandler()} className="hide_block_btn" sx={{ background: "#2a88c3", color: "#fff" }}>{t("chat.yes")}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CuModel>



      {/* Report User Dialog */}
      <CuModel open={openReportDialog} onClose={handleReportDialogClose}>
        <Grid container sx={{ p: "20px", justifyContent: "start" }}>
          <Grid item xs={12} textAlign={"left"}>
            <Typography variant="h6" gutterBottom>
              <FlagIcon sx={{ verticalAlign: "middle", marginRight: "8px" }} />
               {t("chat.reportConversation")}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              {t("chat.reportConfirmMessage")}
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="right" sx={{ mt: 2 }}>

            <Button
              variant="outlined"
              sx={{ mr: 2 }}
              onClick={handleReportDialogClose}
            >
              {t("cancel")}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleReportConfirm}
            >
              {t("chat.report")}
            </Button>
          </Grid>
        </Grid>
      </CuModel>

    </>
  );
}
